import { render, staticRenderFns } from "./IsMainBusinessForm.vue?vue&type=template&id=cf7b11f6&scoped=true&"
import script from "./IsMainBusinessForm.vue?vue&type=script&lang=js&"
export * from "./IsMainBusinessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7b11f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
